import React, { useState } from 'react';
import InvoiceTemplate from '../manager/InvoiceTemplate';
import SystemConfigForm from '../manager/SystemConfigForm';
import SalesByAmountTab from './SalesByAmountTab';
import SalesByOrderTab from './SalesByOrderTab';
import SalesByItemTab from './SalesByItemTab';



const SalesTab = () => {
  const [activeTab, setActiveTab] = useState('salesByAmount');

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div className="customer-details-tab">
      <div className={`tab ${activeTab === 'salesByAmount' ? 'active' : ''}`} onClick={() => handleTabClick('salesByAmount')}>
       Sales by amount
      </div>
      <div className={`tab ${activeTab === 'salesByOrders' ? 'active' : ''}`} onClick={() => handleTabClick('salesByOrders')}>
      Sales by orders
      </div>
      <div className={`tab ${activeTab === 'salesByItem' ? 'active' : ''}`} onClick={() => handleTabClick('salesByItem')}>
        Sales by item
      </div>
      
    <div className='order-details-tab-divider'></div>
      <div className="">
        {activeTab === 'salesByAmount' && (
        <div className="details-content">
           <SalesByAmountTab />
            
        </div>
          
        )}

        {activeTab === 'salesByOrders' && (
          <div className="activity-content">
            <section>
                <SalesByOrderTab />
            </section>
          </div>
        )}
       
       {activeTab === 'salesByItem' && (
          <div className="activity-content">
            <section>
            <SalesByItemTab />
            </section>
          </div>
        )}
      </div>
    </div>
  );
};

export default SalesTab;
